import { alpha, Icon } from "@mui/material";
import { styled } from '@mui/material/styles';
import clsx from "clsx";
import React from "react";
import { useTranslation } from "react-i18next";
import feimg from "../images/features.png";
import "./style.css";

const PREFIX = 'WpoFeatures';

const classes = {
  root: `${PREFIX}-root`,
  featuresItem2: `${PREFIX}-featuresItem2`,
  featuresItem: `${PREFIX}-featuresItem`,
  icon: `${PREFIX}-icon`
};

const Root = styled('div')((
  {
    theme
  }
) => ({
  [`&.${classes.root}`]: {
    "& .wpo-features-item .fi": {
      color: theme.palette.primary.main,
    },
    "& .wpo-features-icon": {
      border: "6px solid",
      borderColor: alpha(theme.palette.common.white, 0.8),
      background: theme.palette.primary.main,
    },
  },

  [`& .${classes.featuresItem2}`]: {
    textAlign: "right",
    [theme.breakpoints.down('lg')]: {
      textAlign: "center",
    },
  },

  [`& .${classes.featuresItem}`]: {
    textAlign: "left",
    [theme.breakpoints.down('lg')]: {
      textAlign: "center",
    },
  },

  [`& .${classes.icon}`]: {
    fontFamily: "Material Icons Outlined",
    fontSize: 50,
    verticalAlign: "middle",
  }
}));

const WpoFeatures = () => {
  const { t } = useTranslation("home");

  const sections = t("home:featureSections", { returnObjects: true });

  return (
    <Root id="features" className={clsx(classes.root, "wpo-features-area")}>
      <div className="container">
        <div className="wpo-section-title text-center">
          <span>{t("home:featuresSubtitle")}</span>
          <h2>{t("home:featuresTitle")}</h2>
        </div>
        <div className="row">
          <div className="col-lg-4 col-md-6">
            <div className={classes.featuresItem2}>
              {sections.slice(0, Math.ceil(sections.length/2)).map((section, i) => (
                <Section
                  key={i}
                  icon={section.icon}
                  title={section.title}
                  body={section.body}
                />
              ))}
            </div>
          </div>
          <div className="col-lg-4 col-md-6 d-none d-lg-block">
            <div className="wpo-features-item">
              <div className="wpo-feature-img">
                <img src={feimg} alt="" />
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6">
            <div className={classes.featuresItem}>
              {sections.slice(Math.floor(sections.length/2)).map((section, i) => (
                <Section
                  key={i}
                  icon={section.icon}
                  title={section.title}
                  body={section.body}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </Root>
  );
};

export default WpoFeatures;

const Section = (props) => {
  const { icon, title, body } = props;

  return (
    <div className="col-lg-12 col-md-12 col-sm-12">
      <div className="wpo-feature-wrap">
        <div className="wpo-features-icon">
          <Icon className={classes.icon}>{icon}</Icon>
        </div>
        <div className="wpo-features-text">
          <h3>{title}</h3>
          <p>{body}</p>
        </div>
      </div>
    </div>
  );
};
